import AdminLayout from "components/layout/AdminLayout"
import MarketingLayout from "components/layout/MarketingLayout"
import NewsletterSettings from "components/marketing/admin/Newsletter"
import { ReactElement } from "react"

const NewsletterPage = () => {
  return <NewsletterSettings />
}

NewsletterPage.getLayout = (page: ReactElement) => {
  return (
    <AdminLayout>
      <MarketingLayout>{page}</MarketingLayout>
    </AdminLayout>
  )
}

export default NewsletterPage
